import { useAppStore } from '@src/shared/zustand/store';

export const setTerms = (value: boolean) =>
  useAppStore.setState({ terms: value });

export const setPrivatePolicy = (value: boolean) =>
  useAppStore.setState({ privatePolicy: value });

export const clearOptions = () =>
  useAppStore.setState({ terms: false, privatePolicy: false });
